import {Core} from "../Base/Core";
import {UIState} from "../enums";
import {UIButton} from "./Tools/Base/UIButton";
import {UISprite} from "./Tools/Base/UISprite";
import {UIText} from "./Tools/Base/UIText";
import {UIAttention} from "./UIAttention";
import {UIBonusTimer} from "./UIBonusTimer";

class BottomPanelButton extends UIButton {

    constructor(icon, label = "", timerProp = "") {
        super();

        this.onClick = this.onClick.bind(this);

        this.timerProp = timerProp;

        this.back = this.addChild(new UISprite("button-big"));
        this.icon = this.back.addChild(new UISprite(icon));
        this.label = this.addChild(new UIText(label));
        this.attention = this.addChild(new UIAttention());
        this.bonusTimer = this.addChild(new UIBonusTimer());

        this.on("pointertap", this.onClick);
        this._initTapHighlight(this.back);
    }

    onClick() {
        this.attention.SetActive(false);
    }

    Update() {
        this.attention.Update();
        if (this.timerProp) {
            this.bonusTimer.Update(Core.Player.Timers[this.timerProp]);
        } else {
            this.bonusTimer.SetActive(false);
        }
    }

    fitLayout(rect) {
        rect = rect.clone();
        this.position.copyFrom(rect);
        this.back.scale.set(rect.width / this.back.texture.width);
        this.back.position.set(rect.width * 0.5, this.back.height * 0.5);

        this.label.fitLayout(new PIXI.Rectangle(0, rect.height * 0.8, rect.width, rect.height * 0.2));
        this.label.position.set(rect.width * 0.5, rect.height * 0.9);

        let badgeRect = new PIXI.Rectangle(rect.width * 0.1, 0, rect.width * 0.1, rect.width * 0.1);
        this.attention.fitRect(badgeRect);

        badgeRect.x = rect.width - rect.width * 0.3;
        this.bonusTimer.fitLayout(badgeRect);
    }


}

class BottomCreaturesButton extends BottomPanelButton {
    constructor() {
        super("monsters-ico", Core.Localizator.Get("monsters"), "discountBoosterTimerId");

        this.attentionInitialized = false;
        this.attentionDic = new Map();
        this.attention.updateFn = () => {
            if (!this.attentionInitialized) {
                if (!Core.Player.Initialized) return;
                this.attentionInitialized = true;
                for (let p of Core.GameData.Planets.planets) {
                    this.attentionDic.set(p.id, 0);
                    if (Core.Player.PlanetsSave.HasPlanet(p.id)) {
                        this.attentionDic.set(p.id, Core.Player.PlanetsSave.GetPlanet(p.id).GetAvailableForPurchaseCreatures().length);
                    }
                }
            }

            let availableNumber = Core.Player.PlanetsSave.CurrentPlanet.GetAvailableForPurchaseCreatures().length;
            if (this.attentionDic.get(Core.Player.PlanetsSave.currentPlanetId) != availableNumber) {
                this.attentionDic.set(Core.Player.PlanetsSave.currentPlanetId, availableNumber);
                return true;
            }
            return false;
        };
    }

    onClick() {
        super.onClick();
        Core.UI.creatures.Show();
        Core.Ads.TriggerInterstitial();
        Core.Player.PlanetsSave.TutorSave.creatures = true;
        Core.UI.tutorial.HideObjectHand(this);
    }

    Update() {
        if (!Core.Player.Initialized) return;
        super.Update();
        this.SetActive(Core.Player.PlanetsSave.CurrentPlanet.planetId != 1 || Core.Player.PlanetsSave.CurrentPlanet.GetAvailableForPurchaseCreatures().length > 0);
        if (Core.Player.PlanetsSave.TutorSave.step === 4 || (Core.Player.PlanetsSave.TutorSave.step === 5 && !Core.UI.creatures.Active)) {
            if (this.Active) Core.UI.tutorial.ShowObjectHand(this);
        }
    }
}

class BottomUpgradesButton extends BottomPanelButton {
    constructor() {
        super("upgrade-ico", Core.Localizator.Get("upgrades"));

        this.attentionInitialized = false;
        this.attentionDic = new Map();
        this.attention.updateFn = () => {
            if (!Core.Player.Initialized) return;
            if (!Core.UI.upgrades || !Core.UI.upgrades.items.length) return;

            if (!this.attentionInitialized) {
                this.attentionInitialized = true;
                for (let p of Core.GameData.Planets.planets) {
                    this.attentionDic.set(p.id, 0);
                    if (Core.Player.PlanetsSave.HasPlanet(p.id)) {
                        let availableNumber = Core.UI.upgrades.items.filter(
                            ({upgradeData}) => Core.Player.PlanetsSave.GetPlanet(p.id).collection.includes(upgradeData.unlockCreatureId)
                        ).length;
                        this.attentionDic.set(p.id, availableNumber);
                    }
                }
            }

            if (this.attentionInitialized) {
                let availableNumber = Core.UI.upgrades.items.filter(
                    ({upgradeData}) => Core.Player.PlanetsSave.CurrentPlanet.collection.includes(upgradeData.unlockCreatureId)
                ).length;
                if (this.attentionDic.get(Core.Player.PlanetsSave.currentPlanetId) != availableNumber) {
                    this.attentionDic.set(Core.Player.PlanetsSave.currentPlanetId, availableNumber);
                    return true;
                }
            }
            return false;
        };
    }

    onClick() {
        super.onClick();
        Core.UI.upgrades.Show();
    }

    Update() {
        if (!Core.Player.Initialized) return;
        super.Update();
        this.SetActive(Core.Player.PlanetsSave.CurrentPlanet.planetId != 1 || Core.Player.PlanetsSave.CurrentPlanet.HasAnyUpgradesAvailable());
    }
}

class BottomBoostersButton extends BottomPanelButton {
    constructor() {
        super("boosters-icon", Core.Localizator.Get("boosters"));

        this.attentionInitialized = false;
        this.attentionDic = new Map();
        this.attention.updateFn = () => {
            if (!this.attentionInitialized) {
                if (!Core.Player.Initialized) return;
                this.attentionInitialized = true;
                for (let p of Core.GameData.Planets.planets) {
                    this.attentionDic.set(p.id, false);
                    if (Core.Player.PlanetsSave.HasPlanet(p.id)) {
                        this.attentionDic.set(p.id, Core.Player.PlanetsSave.GetPlanet(p.id).collection.includes(Core.GameData.Gameplay.boostersCreatureLock));
                    }
                }
            }

            if (this.attentionInitialized) {
                // update ui
                let hasBoosters = Core.Player.PlanetsSave.CurrentPlanet.collection.includes(Core.GameData.Gameplay.boostersCreatureLock);
                if (this.attentionDic.get(Core.Player.PlanetsSave.currentPlanetId) != hasBoosters) {
                    this.attentionDic.set(Core.Player.PlanetsSave.currentPlanetId, hasBoosters);
                    return true;
                }
            }
            return false;
        };
    }

    onClick() {
        Core.UI.SetState(UIState.Boosters);
        super.onClick();
    }

    Update() {
        if (!Core.Player.Initialized) return;
        super.Update();
        this.SetActive(Core.Player.PlanetsSave.CurrentPlanet.planetId != 1 || Core.Player.PlanetsSave.CurrentPlanet.collection.includes(Core.GameData.Gameplay.boostersCreatureLock));
    }
}

class BottomMapButton extends BottomPanelButton {
    constructor() {
        super("map-icon", Core.Localizator.Get("map"));

        this.attentionInitialized = false;
        this.attentionDic = new Map();
        this.attention.updateFn = () => {
            if (!this.attentionInitialized) {
                if (!Core.Player.Initialized) return;
                this.attentionInitialized = true;
                for (let p of Core.GameData.Planets.planets) {
                    this.attentionDic.set(p.id, false);
                    if (Core.Player.PlanetsSave.HasPlanet(p.id)) {
                        this.attentionDic.set(p.id, Core.Player.PlanetsSave.GetPlanet(p.id).collection.includes(Core.GameData.Gameplay.mapCreatureLock));
                    }
                }
            }

            let hasMap = Core.Player.PlanetsSave.CurrentPlanet.collection.includes(Core.GameData.Gameplay.mapCreatureLock);
            if (this.attentionDic.get(Core.Player.PlanetsSave.currentPlanetId) != hasMap) {
                this.attentionDic.set(Core.Player.PlanetsSave.currentPlanetId, hasMap);
                return true;
            }
            let missionAttention = Core.Player.Missions.HasActiveMission() && !Core.Player.Missions.IsInProgress();
            if (missionAttention) {
                return true;
            }
            return false;
        };
    }

    onClick() {
        super.onClick();
        Core.UI.SetState(UIState.Map);
        Core.Audio.Play("UIToMap");
        Core.Player.PlanetsSave.TutorSave.map = true;
        Core.UI.tutorial.HideObjectHand(this);
    }

    Update() {
        if (!Core.Player.Initialized) return;
        super.Update();
        this.SetActive(Core.Player.PlanetsSave.CurrentPlanet.planetId != 1 || Core.Player.PlanetsSave.CurrentPlanet.collection.includes(Core.GameData.Gameplay.mapCreatureLock));
        if (Core.Player.PlanetsSave.TutorSave.step >= 8 && !Core.UI.map.Active) {
            if (this.Active) Core.UI.tutorial.ShowObjectHand(this);
        }
    }
}

export class BottomPanelButtons extends PIXI.Container {
    constructor() {
        super();
        this.creatures = this.addChild(new BottomCreaturesButton());
        this.upgrades = this.addChild(new BottomUpgradesButton());
        this.boosters = this.addChild(new BottomBoostersButton());
        this.map = this.addChild(new BottomMapButton());
        this.buttons = [
            this.creatures,
            this.upgrades,
            this.boosters,
            this.map,
        ];
    }

    Update() {
        for (let button of this.buttons) {
            button.Update();
        }
    }

    fitLayout(rect) {

        this.position.copyFrom(rect);

        // First button is bigger
        let bigButton = rect.clone();
        bigButton.y = 0;
        bigButton.width = bigButton.height * 0.75;

        let smallButton = bigButton.clone();
        smallButton.width *= 0.8;
        smallButton.height *= 0.8;
        smallButton.y = rect.height - smallButton.height;

        let padding = Math.min(rect.width * 0.05, 20);
        let totalWidth = bigButton.width + (smallButton.width + padding) * (this.buttons.length - 1);
        bigButton.x = (rect.width - totalWidth) * 0.5;
        smallButton.x = bigButton.right + padding;

        for (let i = 0; i < this.buttons.length; i++) {
            if (i === 0) {
                this.buttons[i].fitLayout(bigButton);
            } else {
                this.buttons[i].fitLayout(smallButton);
                smallButton.x += smallButton.width + padding;
            }
        }
    }
}
